import { Carousel } from '@belong/ui';
import { WearAndTearFeatureItem } from 'lease-signing-flow-v2/components/wear-and-tear-feature-item/wear-and-tear-feature-item';
import { features } from 'lease-signing-flow-v2/constants/wear-and-tear';

export const WearAndTearFeatureCarousel = () => (
  <div className="mt-xl">
    <Carousel>
      {features.map((feature, index) => (
        <div className="flex min-w-full justify-center" key={index}>
          <div>
            <WearAndTearFeatureItem
              image={feature.image}
              title={feature.title}
            />
          </div>
        </div>
      ))}
    </Carousel>
  </div>
);
